import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import Riwayat from "./pages/Riwayat";
import Jurnal from "./pages/Jurnal";
import Akun from "./pages/Akun";
import Izin from "./pages/Izin";
import JurnalHarian from "./pages/JurnalHarian";
import JurnalMingguan from "./pages/JurnalMingguan";
import InputJurnalHarian from "./pages/InputJurnalHarian";
import InputJurnalMingguan from "./pages/inputJurnalMingguan";
import { ProtectedRoute, GuruProtectedRoute, RedirectIfAuthenticated } from "./utils/RouteGuards";
import GuruPortal from "./pages/GuruPortal";
import JadwalPage from "./pages/JadwalPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />

        <Route
          path="/login"
          element={
            <RedirectIfAuthenticated>
              <LoginPage />
            </RedirectIfAuthenticated>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jadwal"
          element={
            <ProtectedRoute>
              <JadwalPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/guru"
          element={
            <GuruProtectedRoute>
              <GuruPortal />
            </GuruProtectedRoute>
          }
        />
        <Route
          path="/riwayat"
          element={
            <ProtectedRoute>
              <Riwayat />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jurnal"
          element={
            <ProtectedRoute>
              <Jurnal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/akun"
          element={
            <ProtectedRoute>
              <Akun />
            </ProtectedRoute>
          }
        />

        <Route
          path="/izin"
          element={
            <ProtectedRoute>
              <Izin />
            </ProtectedRoute>
          }
        />

        <Route
          path="/jurnal-harian"
          element={
            <ProtectedRoute>
              <JurnalHarian />
            </ProtectedRoute>
          }
        />
        <Route
          path="/jurnal-mingguan"
          element={
            <ProtectedRoute>
              <JurnalMingguan />
            </ProtectedRoute>
          }
        />
        <Route
          path="/input-jurnal"
          element={
            <ProtectedRoute>
              <InputJurnalHarian />
            </ProtectedRoute>
          }
        />
        <Route
          path="/input-jurnal-mingguan"
          element={
            <ProtectedRoute>
              <InputJurnalMingguan />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
